// 取引履歴の検索・フィルタバー。
// テキスト検索 + 種別 + 状態 + 取引 + 取得期間 + 条件クリア の 6 部品を 1 行で並べる。
// 2026-05-14 リファクタで src/pages/InputPage.tsx から分離。
import { Search, X } from 'lucide-react'

export type TypeFilter = 'all' | 'income' | 'expense'
export type StatusFilter = 'all' | 'pending' | 'confirmed'
export type RecurringFilter = 'all' | 'recurring' | 'onetime'

interface Props {
  search: string
  onSearch: (value: string) => void
  type: TypeFilter
  onType: (value: TypeFilter) => void
  status: StatusFilter
  onStatus: (value: StatusFilter) => void
  recurring: RecurringFilter
  onRecurring: (value: RecurringFilter) => void
  periodDays: number
  onPeriodDays: (days: number) => void
}

export default function InputHistoryFilters({
  search, onSearch, type, onType, status, onStatus, recurring, onRecurring, periodDays, onPeriodDays,
}: Props) {
  const hasActiveFilter = !!search || type !== 'all' || status !== 'all' || recurring !== 'all'

  const handleClear = () => {
    onSearch('')
    onType('all')
    onStatus('all')
    onRecurring('all')
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {/* テキスト検索（取引先・カテゴリ・メモ・日付・金額に対する完全一致 or 部分一致） */}
      <div className="relative flex-1 min-w-[180px]">
        <Search className="absolute left-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none" />
        <input
          type="search"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="取引先・カテゴリ・メモ・日付・金額で検索"
          className="w-full pl-7 pr-7 py-1 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:ring-1 focus:ring-blue-400"
        />
        {search && (
          <button
            type="button"
            onClick={() => onSearch('')}
            className="absolute right-1.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700"
            title="クリア"
          >
            <X className="w-3 h-3" />
          </button>
        )}
      </div>

      <select
        value={type}
        onChange={(e) => onType(e.target.value as TypeFilter)}
        className="px-2 py-1 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:ring-1 focus:ring-blue-400"
        title="収入/支出で絞り込み"
      >
        <option value="all">種別: 全て</option>
        <option value="income">収入のみ</option>
        <option value="expense">支出のみ</option>
      </select>

      <select
        value={status}
        onChange={(e) => onStatus(e.target.value as StatusFilter)}
        className="px-2 py-1 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:ring-1 focus:ring-blue-400"
        title="確認状態で絞り込み"
      >
        <option value="all">状態: 全て</option>
        <option value="pending">未確認のみ</option>
        <option value="confirmed">確認済みのみ</option>
      </select>

      <select
        value={recurring}
        onChange={(e) => onRecurring(e.target.value as RecurringFilter)}
        className="px-2 py-1 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:ring-1 focus:ring-blue-400"
        title="単発/定期で絞り込み"
      >
        <option value="all">取引: 全て</option>
        <option value="recurring">定期のみ</option>
        <option value="onetime">単発のみ</option>
      </select>

      <select
        value={periodDays}
        onChange={(e) => onPeriodDays(Number(e.target.value))}
        className="px-2 py-1 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:ring-1 focus:ring-blue-400"
        title="取得期間"
      >
        <option value={7}>直近7日</option>
        <option value={30}>直近30日</option>
        <option value={60}>直近60日</option>
        <option value={90}>直近90日</option>
        <option value={180}>直近180日</option>
        <option value={365}>直近1年</option>
      </select>

      {hasActiveFilter && (
        <button
          type="button"
          onClick={handleClear}
          className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 text-gray-600 rounded transition"
          title="絞り込みをクリア"
        >
          条件クリア
        </button>
      )}
    </div>
  )
}
